// Supabase client - uses env vars for production; fallback for generated/dev.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? "https://brkzsfbiuazrbmpnpzyl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJya3pzZmJpdWF6cmJtcG5wenlsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3Njg3MTYsImV4cCI6MjA2ODM0NDcxNn0.5F4wv_bhgY_HCwxOdGSxbmcXKiem3VEY0PQG3n6U_nw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof window !== 'undefined' ? window.sessionStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  }
});